import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { LabelRequiredInput, LabelError } from 'shared/components/Labels';
import { TextField } from 'shared/components/form/Inputs';
import { Button } from 'shared/components/Buttons';

import { colors } from 'shared/defaultTheme';
import { cleanSpaceString } from 'shared/utils';

const Form = ({ defaultValue, onCancel, onSubmit }) => {
  const { t } = useTranslation();
  const { selectedDefaultLanguage } = useSelector((state) => state.topBar);
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: defaultValue
      ? {
          tagName: defaultValue.name,
        }
      : undefined,
  });

  const getNameSelectedLanguage = (i18List) => {
    if (i18List) {
      const findName = i18List.find((x) => x.i18Code === selectedDefaultLanguage);
      if (findName && findName?.i18Name !== '') {
        return findName?.i18Name;
      }
      return i18List[0].i18Name;
    }
    return null;
  };

  useEffect(() => {
    if (defaultValue) {
      setValue('tagName', getNameSelectedLanguage(defaultValue.i18List));
    }
  }, [defaultValue]);

  return (
    <Row className="row-content w-100">
      <Col sm={12}>
        <form className="form form-field" noValidate onSubmit={handleSubmit(onSubmit)}>
          <Row className="w-100">
            <Col sm={12}>
              <div className="form__form-group">
                <LabelRequiredInput
                  className="form__form-group-label"
                  label="Nombre de Etiqueta"
                  color={colors.black}
                  error={errors.name !== undefined}
                />
                <Controller
                  name="tagName"
                  control={control}
                  defaultValue=""
                  rules={{ required: { value: true, message: t('general_required_field') } }}
                  render={({ field }) => (
                    <TextField
                      value={field.value}
                      onChange={(e) => {
                        const newEvent = cleanSpaceString(e);
                        field.onChange(newEvent);
                      }}
                      onBlur={field.onBlur}
                      error={errors.tagName !== undefined}
                    />
                  )}
                />
                {errors.tagName && <LabelError label={errors.tagName.message} />}
              </div>
            </Col>
          </Row>
          <Row className="w-100">
            <Col className="d-flex flex-row justify-content-end" sm={12}>
              <Button
                className="text-uppercase mr-4"
                type="button"
                color="secondary"
                label={t('general_button_cancel')}
                onClick={onCancel}
              />
              <Button
                className="text-uppercase"
                type="submit"
                color="primary"
                label={t(defaultValue ? 'general_button_update' : 'general_add')}
              />
            </Col>
          </Row>
        </form>
      </Col>
    </Row>
  );
};

Form.defaultProps = {
  defaultValue: undefined,
};

Form.propTypes = {
  defaultValue: PropTypes.shape({
    name: PropTypes.string,
    i18List: PropTypes.arrayOf(PropTypes.shape()),
  }),
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default Form;
